export const SET_VENUES = 'SET_VENUES';
export const SET_VENUE = 'SET_VENUE';
export const ADD_VENUE = 'ADD_VENUE';
export const UPDATE_VENUE = 'UPDATE_VENUE';
export const REMOVE_VENUE = 'REMOVE_VENUE';
export const CLEAR_VENUE = 'CLEAR_VENUE';
export const CLEAR_VENUES = 'CLEAR_VENUES';
